import styled from 'styled-components'

import Card from '../../../../surfaces/Card/Card'

export const BannerCard = styled(Card)`
  margin-left: ${props => props.theme.spacings.medium};
  margin-right: ${props => props.theme.spacings.medium};
  background-color: ${props => props.theme.colors.secondary.lighter};
`
